// extracted by mini-css-extract-plugin
export default {"Registration":"Registration_Registration__U5Lya","Buttons":"Registration_Buttons__aKfGm","Highlighted":"Registration_Highlighted__n3B7W"};